import React from "react";

import Localize from "components/service/localize";
import TranslatedText from "components/service/translated-text";
import CraftTypeHelper from "../helpers/craft-type-helper";
import { CUSTOM_CRAFT_TITLES_ENABLED, isCustomCraftTitle } from "../helpers/craft-title-helper";


const CraftTypeLabel = ({
        type,
        title,
        preferCustomTitle = false,
        fallback = ""
    }) => {

    const localizeParams = CraftTypeHelper.localizeParams(type);
    const useCustomTitle = preferCustomTitle && CUSTOM_CRAFT_TITLES_ENABLED &&
        isCustomCraftTitle(type, title, localizeParams);

    if(localizeParams && !useCustomTitle){
        return (
            <Localize { ...localizeParams.params }>
                { localizeParams.key }
            </Localize>
        );
    }

    if(!title) return fallback || null;

    return (
        <TranslatedText
            text={ title }
            namespace="craft-title"
            context={ `craft-title:${ type || title }` }
            fallback={ fallback }
        />
    );
};

export default CraftTypeLabel;
